var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:['section', 'section-wrap', _vm.$route.name]},[_c('navigation'),_c('div',{staticClass:"columns is-marginless"},[(_vm.notPrinting)?_c('div',{class:[
        'column',
        'aside',
        'hero',
        'is-fullheight',
        'is-full-tablet',
        'is-3-desktop',
        'is-2-widescreen',
        'nav-left',
        { 'is-nav-toggle': _vm.navToggle }
      ]},[(_vm.isAuth)?_c('left-menu'):_vm._e()],1):_vm._e(),_c('div',{staticClass:"column col-content is-9-desktop is-10-widescreen is-full-tablet is-mobile"},[_c('div',[_c('section',{staticClass:"section"},[_c('transition',{attrs:{"name":"slide"}},[_c('router-view')],1)],1)])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }